export default __webpack_public_path__ + "static/media/Accessibility.a6eeb1ce.svg";